import { EXTERNAL_ROUTES } from "@/const/routes.constants"
import { useTranslation } from "@/hooks/useTranslation"
import { ReadOutlined } from "@/icons"
import { LinkButton } from "@/molecules/LinkButton"

import type { ReadInstructionButtonProps } from "./ReadInstructionButton.types"

export const ReadInstructionButton = (props: ReadInstructionButtonProps) => {
  const { t } = useTranslation()
  const href =
    "href" in props ? props.href : `${EXTERNAL_ROUTES.API_DOCS}${props.needle}`

  return (
    <LinkButton
      icon={<ReadOutlined />}
      target="_blank"
      type="link"
      size="small"
      href={href}
    >
      {t("general.readInstructions")}
    </LinkButton>
  )
}
